module.exports = __webpack_public_path__ + "static/media/resume.d27dc696.pdf";